import React, {useEffect, useState} from "react";
import Loading from "../../components/Loading/Loading";
import {useParams} from "react-router-dom";
import useCreditService from "../../api/services/useCreditService";
import CreditsDashboard from "../../components/CreditsDashboard/CreditsDashboard";

const UserCreditActions = () => {

  const {userShowCollection} = useCreditService()
  const [credits, setCredits] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const {bookingId} = useParams()

  useEffect(() => {
    userShowCollection(
      (credits) => {
        setCredits(credits)
        setIsLoading(false)
      },
      () => {
        setIsLoading(false)

      },
      bookingId
    )
  }, [])

  return (
    <div className="page-user-credit-actions">
      <h1>Stand credits</h1>
      {isLoading ?
        <Loading/>
        :
        <div className="credits">
          <CreditsDashboard
            credits={credits}
          />
        </div>
      }
    </div>
  )
}

export default UserCreditActions
